(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("osjsPanels", [], factory);
	else if(typeof exports === 'object')
		exports["osjsPanels"] = factory();
	else
		root["osjsPanels"] = factory();
})(window, function() {
return 